var exports = {
  "DR": "Box_0__HkKqOF",
  "wy": "Box_1__kjXarr",
  "pv": "Box_2__oyay5f",
  "w9": "Box_3__EZ1k1_",
  "pQ": "Box_4__0ZM1Bz",
};

module.exports = exports;
